import React from 'react';
import {
  DashboardContainer,
  SummaryContainer,
  SummaryContainerCell,
  TitleContainer,
  SubTitle
} from '../../styles';
import {
  IOpenOrderStatusData,
  IOpenOrderStatusState
} from '../../../../store/ducks/dashboard/types';
import OpenOrderStatusTable from './OpenOrderStatusTable';
import { KeyValueItem } from '@gerdau/hefesto-mais-web/KeyValueItem';
import { formatNumberTon } from '../../../../utils/formatNumbers';
import { Button } from '@gerdau/hefesto/Button';
import { Title } from '@gerdau/hefesto/Title';
import { SummaryWrapper } from './styles';

interface IOpenOrderStatusProps {
  openOrderStatusState: IOpenOrderStatusState;
  errorMessageBlock: React.ReactNode;
  skuDetailClick(): void;
}

const OpenOrderStatus: React.FC<IOpenOrderStatusProps> = ({
  openOrderStatusState,
  errorMessageBlock,
  skuDetailClick,
  children
}) => {
  const totalRow = {
    key: 0,
    divisionProducts: 'Total',
    totalDelivery: '0',
    totalPending: '0',
    totalRequested: '0',
    totalShipment: '0'
  };

  openOrderStatusState?.dashboard?.forEach((item: IOpenOrderStatusData) => {
    const { totalDelivery, totalPending, totalRequested, totalShipment } = item;

    totalRow.totalDelivery = (
      Number(totalRow.totalDelivery) + Number(totalDelivery.replace(/,/g, ''))
    ).toString();
    totalRow.totalPending = (
      Number(totalRow.totalPending) + Number(totalPending.replace(/,/g, ''))
    ).toString();
    totalRow.totalRequested = (
      Number(totalRow.totalRequested) + Number(totalRequested.replace(/,/g, ''))
    ).toString();
    totalRow.totalShipment = (
      Number(totalRow.totalShipment) + Number(totalShipment.replace(/,/g, ''))
    ).toString();
  });

  return (
    <DashboardContainer>
      <TitleContainer>
        <Title level={3}>Volume de pedidos por status (t)</Title>
        <SubTitle>
          {openOrderStatusState.lastUpdateMoment &&
          !openOrderStatusState.loading ? (
            <>
              Atualizado em{' '}
              {openOrderStatusState.lastUpdateMoment.format('DD/MM/YYYY')} às{' '}
              {openOrderStatusState.lastUpdateMoment.format('HH:mm')} horas
            </>
          ) : (
            <></>
          )}
        </SubTitle>
      </TitleContainer>
      <SummaryWrapper>
        <SummaryContainer>
          <SummaryContainerCell>
            <KeyValueItem title="">Total</KeyValueItem>
          </SummaryContainerCell>
          <SummaryContainerCell>
            <KeyValueItem title="Solicitado">{`${formatNumberTon(
              totalRow.totalRequested.toString()
            )} t`}</KeyValueItem>
          </SummaryContainerCell>
          <SummaryContainerCell>
            <KeyValueItem title="Em remessa">{`${formatNumberTon(
              totalRow.totalDelivery.toString()
            )} t`}</KeyValueItem>
          </SummaryContainerCell>
          <SummaryContainerCell>
            <KeyValueItem title="Em carregamento">{`${formatNumberTon(
              totalRow.totalShipment.toString()
            )} t`}</KeyValueItem>
          </SummaryContainerCell>
          <SummaryContainerCell>
            <KeyValueItem title="Saldo">{`${formatNumberTon(
              totalRow.totalPending.toString()
            )} t`}</KeyValueItem>
          </SummaryContainerCell>
        </SummaryContainer>
        <SummaryContainer>
          <Button
            name="exportDuplicate"
            onClick={skuDetailClick}
            variant="secondary"
            disabled={openOrderStatusState.loading}
            loading={openOrderStatusState.loading}
          >
            Ver volume SKU
          </Button>
        </SummaryContainer>
      </SummaryWrapper>

      {openOrderStatusState.error && !openOrderStatusState.loading && (
        <>{errorMessageBlock}</>
      )}

      {openOrderStatusState.loading && !openOrderStatusState.error && (
        <>{children}</>
      )}

      {!openOrderStatusState.error && !openOrderStatusState.loading && (
        <OpenOrderStatusTable openOrderStatusState={openOrderStatusState} />
      )}
    </DashboardContainer>
  );
};

export default OpenOrderStatus;
